export const CFOP_HTML_URL =
  'https://www.confaz.fazenda.gov.br/legislacao/ajustes/sinief/cfop_cvsn_70_vigente';

export const CFOP_GOLDEN_COMPRA_COMERCIALIZACAO = '1102';
export const CFOP_GOLDEN_VENDA_TERCEIROS = '5102';
export const CFOP_MIN_CODES = 600;
export const CFOP_MAX_CODES = 750;
